module.exports = __webpack_public_path__ + "img/4.dc616732.jpg";